module.exports = __webpack_public_path__ + "img/device.67167861.webp";